<template>
  <b-card title="Selection Records">
    <b-card-text>
      Your previously saved selection records appear here. To start a new selection record to evidence your client
      fact find outcome please go to
      <router-link :to="{ name: 'current-products' }">Current Products</router-link>,
      click the Selection record button and proceed.
    </b-card-text>
    <loading-container v-if="userReports.loading" />
    <error-display v-else-if="userReports.error" />
    <div v-else>
      <b-table
        responsive="sm"
        hover
        show-empty
        :items="userReports.data"
        :fields="userReports.fields"
        :sort-by.sync="userReports.sortBy"
        :sort-desc.sync="userReports.sortDesc"
        :per-page="userReports.perPage"
        :current-page="userReports.currentPage"
      >
        <template #cell(download)="data">
          <a
            :href="`${baseURL}cfc/dynamicreport/selection/selectionpdf.cfm?selectionId=${data.item.id}`"
            target="_blank"
          >
            <b-img
              height="40"
              :src="require('@/assets/images/icons/file-icons/adobe_pdf_icon_modern.png')"
              style="width: auto;"
              alt="Download selection record PDF"
            />
          </a>
        </template>
      </b-table>
      <div class="d-flex p-2 justify-content-between align-items-center">
        <span>{{ userReports.data.length }} results found | Showing results {{ showingReports }}</span>
        <b-pagination
          v-model="userReports.currentPage"
          :total-rows="userReports.data.length"
          :per-page="userReports.perPage"
          align="center"
          size="sm"
          class="my-0"
        />
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BCardText, BImg, BPagination, BTable,
} from 'bootstrap-vue'
import ErrorDisplay from '@/views/components/ErrorDisplay.vue'
import LoadingContainer from '@/views/components/LoadingContainer.vue'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

export default {
  components: {
    BCard,
    BCardText,
    BImg,
    BPagination,
    BTable,
    ErrorDisplay,
    LoadingContainer,
  },
  data() {
    return {
      baseURL: process.env.VUE_APP_BACKEND_PATH,
      userReports: {
        data: [],
        fields: [
          {
            key: 'id',
            label: 'Id',
            sortable: true,
            thStyle: { width: '10%' },
          },
          {
            key: 'reportName',
            label: 'Report name',
            sortable: true,
            thStyle: { width: '40%' },
          },
          {
            key: 'created',
            label: 'Created',
            sortable: true,
            formatter: this.dateFormatter,
            thStyle: { width: '20%' },
          },
          {
            key: 'download',
            label: 'Download',
            sortable: false,
            thStyle: { width: '10%' },
            class: 'text-center',
          },
        ],
        sortBy: null,
        sortDesc: false,
        currentPage: 1,
        perPage: 10,
        loading: false,
        error: false,
      },
    }
  },
  computed: {
    showingReports() {
      if (this.userReports.data.length === 0) return 'from 0 to 0'
      const from = (this.userReports.currentPage - 1) * this.userReports.perPage + 1
      const to = Math.min(this.userReports.currentPage * this.userReports.perPage, this.userReports.data.length)
      return `from ${from} to ${to}`
    },
  },
  mounted() {
    this.loadUserReports()
  },
  activated() {
    this.loadUserReports()
  },
  methods: {
    loadUserReports() {
      if (this.userReports.loading) return
      this.userReports.loading = true
      this.userReports.error = false
      this.$http
        .get('research.cfc?method=getUserReports')
        .then(response => {
          this.userReports.data = response.data.content
          this.userReports.currentPage = 1
        })
        .catch(error => {
          this.userReports.error = error
        })
        .finally(() => {
          this.userReports.loading = false
        })
    },
    dateFormatter(value) {
      dayjs.extend(utc)
      return dayjs(value).isValid() ? dayjs.utc(value).format('DD MMM YYYY HH:mm:ss') : `${value}`
    },
  },
}
</script>
